<template lang="pug">
  .agencies
    PhoValidationProvider(:rules="rules" :name="$t($lang.content.CATEGORY)")
      v-autocomplete(
        v-model="lazyValue"
        dense
        outlined
        clearable
        attach
        multiple
        item-value="id"
        item-text="id"
        :disabled="isDisabled"
        :items="lazyAgencyCategories"
        :label="$t($lang.content.CATEGORY)"
        :placeholder="$t($lang.app.CHOOSE)"
        :search-input.sync="search"
        @change="clearSearch"
      )
</template>
<script>
import {
  onMounted, ref, watch, computed,
} from 'vue';
import { useModelAutoBinding } from '@/helpers/misc/binding';
import { filterSelectedValues } from '@/helpers/content';
import { getAgencyCategories } from '@/api/agency/AgencyContentApi';
import { PhoValidationProvider } from '@/components/misc/form';
import { useSelectedSorter } from '@/helpers/misc';

import { agencyTabItems } from './constants';

export default {
  name: 'AgencyCategory',
  components: {
    PhoValidationProvider,
  },
  props: {
    value: {
      type: Array,
    },
    contentTypes: {
      type: Array,
      default: () => ([]),
    },
    agencyIds: {
      type: Array,
      default: () => ([]),
    },
    tabName: {
      type: String,
    },
    selectedTab: {
      type: Number,
      default: () => 0,
    },
    rules: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const { lazyValue } = useModelAutoBinding(emit, props);
    const isArchiveTab = computed(() => props.selectedTab === agencyTabItems.archive);

    const lazyItems = ref([]);
    const search = ref('');

    const clearSearch = () => {
      search.value = '';
    };

    const loadAgencyCategories = async (contentTypes, agencyIds, tabName) => {
      if (!isArchiveTab.value && !contentTypes.length && !tabName) {
        return;
      }

      const filter = { contentTypes, agencyIds };

      if (!isArchiveTab.value) {
        filter.tabName = tabName;
      }

      lazyItems.value = await getAgencyCategories(filter);
    };

    watch(() => props.contentTypes, async newValue => {
      await loadAgencyCategories(newValue, props.agencyIds, props.tabName);
      search.value = '';
    });

    watch(() => props.agencyIds, async newValue => {
      await loadAgencyCategories(props.contentTypes, newValue, props.tabName);
      search.value = '';
    });

    watch(() => props.tabName, async newValue => {
      await loadAgencyCategories(props.contentTypes, props.agencyIds, newValue);
      search.value = '';
    });

    onMounted(async () => {
      await loadAgencyCategories(props.contentTypes, props.agencyIds, props.tabName);
    });

    const [lazyAgencyCategories] = useSelectedSorter(lazyItems, lazyValue, filterSelectedValues, 'id');

    return {
      search,
      lazyValue,
      lazyAgencyCategories,
      clearSearch,
    };
  },
};
</script>
